module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl('locashop-loading.gif'),
      "alt": "Carregando..."
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac023aa0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Loading.vue
// module id = 319
// module chunks = 18